import moment from 'moment';

const cookiesUtils = {
  saveValue: (value, name, country, expirationDays = 30, domain) => {
    const expires = `expires=${moment().add(expirationDays, 'days').toDate().toUTCString()}`;
    let cookieName = name;
    if (country) {
      cookieName = `${country}.credit24.${name}`;
    }
    const cookie = [
      cookieName, '=', encodeURIComponent(value),
      `;${expires}`,
      ';path=/',
      domain ? `;domain=${domain}` : '',
    ].join('');
    document.cookie = cookie;
  },

  getValue: (name, country, defaultValue = '') => {
    const cookieName = `${country}.credit24.${name}`;
    const cookiesArray = document.cookie.split(';');
    const length = cookiesArray.length;
    for (let i = 0; i < length; i += 1) {
      const cookiePair = cookiesArray[i].split('=');
      if (cookiePair[0].trim() === cookieName) {
        return cookiePair[1] || defaultValue;
      }
    }
    return defaultValue;
  },

  getBoolValue: (name, country, defaultValue = false) => {
    const value = cookiesUtils.getValue(name, country, defaultValue);
    return value === 'true';
  },

  removeValue: (name, country) => {
    cookiesUtils.saveValue('', name, country, 0);
  },
};

let cookiesManager;

export default function getCookiesManager() {
  if (cookiesManager === undefined) {
    cookiesManager = navigator.cookieEnabled ? cookiesUtils : null;
  }
  return cookiesManager;
}
